import { ApiState } from "infrastructure/api";
import { RootState } from "infrastructure/store";
import { PaymentMethod } from "./types";


export const selectIsPaymentMethodsLoading = (state: RootState) =>
    state.paymentMethods.paymentMethodsLoadingState === ApiState.Pending;

export const selectPaymentMethods = (state: RootState) =>
    state.paymentMethods.paymentMethodsSlice;

export const selectPaymentMethodsData = (
    filterFn: (paymentMethod: PaymentMethod) => boolean = () => true
) => (state: RootState): Array<PaymentMethod> => (
    selectPaymentMethods(state)?.data ?? []
).filter(filterFn);

export const selectPaymentMethodsOptions = (
    filterFn: (paymentMethod: PaymentMethod) => boolean = () => true
) => (state: RootState) =>
        selectPaymentMethodsData(filterFn)(state)
            .map(({ coreId, name }: PaymentMethod) => ({
                id: coreId,
                name: `${name} (${coreId})`
            }));

export const selectPaymentMethodsTags = (
    filterFn: (paymentMethod: PaymentMethod) => boolean = () => true
) => (state: RootState) => {
    const uniqueTags = new Set<string>(
        selectPaymentMethodsData(filterFn)(state)
            .map(({ tag }: PaymentMethod) => tag)
    );

    return Array.from(uniqueTags)
        .map(name => ({
            id: name,
            name
        }));
};

export const selectPaymentMethodsByProperty = <TProperty extends keyof PaymentMethod>(
    property: TProperty,
    values: Array<PaymentMethod[TProperty]>
) => (state: RootState) =>
        selectPaymentMethodsData()(state)
            .filter((paymentMethod: PaymentMethod) => values.includes(paymentMethod[property])) ?? [];
